// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N-Gf","placeholdersHeader":"styles_placeholdersHeader__1___L","editorStyle":"styles_editorStyle__3tREa","placeholdersBox":"styles_placeholdersBox__iEzhG"};